import React, { FC, useEffect, useState } from 'react';
import get from 'lodash/get';
import { useUrlBuilder } from 'hooks/useUrlBuilder';
import { scrollToY } from '../../helpers/animatedScrolling';
import { newsletterSubscribeSelectedEvent } from '../../common/models/TrackingEvents';
import { track } from '../../helpers/tracking/tracking';

const NewsletterModalButton: FC<{ header?: boolean }> = ({ header }) => {
  const [formElement, setFormElement] = useState(null);
  const { withCDN } = useUrlBuilder();

  useEffect(() => {
    setFormElement(
      document.querySelector('#klaviyo-embed-footer') || document.querySelector('#klaviyo-embed-homepage'),
    );
  }, []);

  const handleClick = (): void => {
    scrollToY(get(formElement, 'offsetTop') - 215);
    track(newsletterSubscribeSelectedEvent);
  };

  return (
    <>
      <div className="label-wrapper" data-cy="wrapper-newsletter-open-modal" onClick={handleClick}>
        <img className="email-img" src={withCDN('mkt/icon/icon_newsletter.png')} />
        <span className="emphatic-text">
          Subscribe <span>to save</span>
        </span>
      </div>
      <style jsx>
        {`
          .email-img {
            width: auto;
            height: auto;
            position: absolute;
            top: 13px;
            left: 9px;
            ${header ? 'filter: invert(100%)' : ''}
          }

          .label-wrapper {
            display: inline-block;
            height: 40px;
            position: relative;
            cursor: pointer;
            width: 300px;
          }

          .emphatic-text {
            position: absolute;
            left: 37px;
            top: 12px;
            color: white;
            font-family: 'Avenir Black', 'Arial Black', sans-serif;
            font-size: 15px;
            text-transform: none;
            width: 100%;
          }
          .emphatic-text > span {
            font-size: 15px;
          }
          .emphatic-text:hover {
            color: #999;
            cursor: pointer;
          }

          @media (min-width: 1024px) {
            .label-wrapper {
              margin-top: ${header ? '-5px' : '8px'};
              margin-left: -10px;
              height: 40px;
            }
            .emphatic-text {
              color: #000;
            }
          }
        `}
      </style>
    </>
  );
};

export { NewsletterModalButton };
